import MasterGenerateArrayField from './MasterGenerateArrayField';

export default MasterGenerateArrayField;
